import { PATHS } from "../utills/paths";
import { Navigate, useLocation } from "react-router-dom";
import { useAuthContext } from "../components/user/AuthProvider";

export default function RoleBasedRoute({ children }) {
  const { pathname, search } = useLocation();
  const { userAccess, user } = useAuthContext();
  const returnUrl = encodeURIComponent(`${pathname}${search || ""}`);

  if (Number(user?.basic_info_prompted) === 0 && pathname !== PATHS.V2.ONBOARDING) {
    return <Navigate to={`${PATHS.V2.ONBOARDING}?returnUrl=${returnUrl}`} replace />;
  }
  // Allowed paths for restricted org admins
  if (
    !userAccess?.isRestrictedOrgAdmin ||
    (userAccess?.isRestrictedOrgAdmin &&
      (pathname === PATHS.V2.HOME ||
        pathname?.startsWith("/user/") ||
        pathname?.startsWith("/plans/") ||
        pathname?.startsWith("/workspace/")))
  ) {
    return children;
  }

  return <Navigate to={PATHS.V2.HOME} replace />;
}
